module.exports = __webpack_public_path__ + "d8fe7241cd7827735b4cf9e5df6c845e.jpg";